import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2/Common/Features`;

class FeaturesService {
  exportExcel(jsonData) {
    return axios
      .post(`${API_URL}/json-to-excel`, jsonData, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  generateNachaFile(nachaEntryModel) {
    return axios
      .post(`${API_URL}/GenerateNachaFile`, nachaEntryModel, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new FeaturesService();
